<div>
    <fa-icon *ngIf="!isEditing" [icon]="faEdit" (click)="onClickEdit()"></fa-icon>
    <fa-icon *ngIf="isEditing" [icon]="faCancel" (click)="onClickCancel()"></fa-icon>
    <fa-icon *ngIf="isEditing" [icon]="faSave" (click)="onClickSave()"></fa-icon>
</div>